import { render, staticRenderFns } from "./annMgmt.vue?vue&type=template&id=39b44a39&scoped=true&"
import script from "./annMgmt.vue?vue&type=script&lang=js&"
export * from "./annMgmt.vue?vue&type=script&lang=js&"
import style0 from "./annMgmt.vue?vue&type=style&index=0&id=39b44a39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b44a39",
  null
  
)

export default component.exports